import { clsx } from 'clsx';
import { InputHTMLAttributes, Ref } from 'react';

export type CheckboxInputElementProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>;

type Props = {
  label: string;
  errorMessage?: string;
  wrapperClassName?: string;
  size?: CheckboxSize;
  labelClassName?: string;
  ref?: Ref<HTMLInputElement>;
} & CheckboxInputElementProps;

// TODO IMPLEMENNT UNIFIED LABEL AND ERROR MESSAGE WRAPPER

export const CheckboxComponent = ({ wrapperClassName, label, errorMessage, size, labelClassName, ref, ...rest }: Props) => (
  <div className={wrapperClassName}>
    <div className="flex items-center">
      <CheckboxInput className={clsx(errorMessage && 'border-red-300')} id={'f' + rest.name} {...rest} size={size} ref={ref} />

      <label
        htmlFor={'f' + rest.name}
        className={clsx('flex text-sm font-medium pr-2 ml-3', rest.disabled && 'text-gray-500', labelClassName)}
      >
        {/* SHOW REQUIRED ASTERIX */}
        {rest.required && <abbr className="text-red-500 mr-1"> *</abbr>}
        <div>{label}</div>
      </label>
    </div>

    {/* DISPLAY ERROR MESSAGE */}
    {errorMessage && <div className="mt-2 text-sm text-red-600 flex">{errorMessage}</div>}
  </div>
);

const baseStyle = clsx(
  'rounded-sm enabled:checked:border-0 enabled:indeterminate:border-0',
  'focus:outline-2 focus:outline-offset-0 focus:outline-focus ring-0',
  'disabled:border-gray-400 disabled:bg-gray-200',
);
const validStyle = clsx(
  'border-gray-500 checked:bg-blue-600 indeterminate:bg-blue-600',
  'enabled:hover:border-blue-700 active:border-blue-800',
  'enabled:checked:hover:bg-blue-700 enabled:checked:active:bg-blue-800',
);
const invalidStyle = clsx(
  'border-red-500 checked:bg-red-500 indeterminate:bg-red-500',
  'enabled:hover:border-red-700 active:border-red-800',
  'enabled:checked:hover:bg-red-700 enabled:checked:active:bg-red-800',
);

const xlStyle = clsx('size-8');
const largeStyle = clsx('size-6');
const smallStyle = clsx('size-4');

export type CheckboxSize = 'L' | 'S' | 'XL';

type CheckboxInputProps = {
  size?: CheckboxSize;
  hasError?: boolean;
  ref?: Ref<HTMLInputElement>;
} & CheckboxInputElementProps;

export const CheckboxInput = ({ hasError, size = 'L', className, ref, ...rest }: CheckboxInputProps) => (
  <input
    type="checkbox"
    className={clsx(
      className,
      baseStyle,
      {
        L: largeStyle,
        S: smallStyle,
        XL: xlStyle,
      }[size],
      hasError ? invalidStyle : validStyle,
    )}
    ref={ref}
    {...rest}
  />
);
